/**
 * Checkout API endpoint schemas
 *
 * Export all Zod schemas and types for checkout-related API endpoints
 */

// The tax line every shipping rate and estimate carries
export { TaxEstimateSchema, type TaxEstimate } from './tax-estimate';

// Shipping rates (authenticated)
export {
  ShippingRatesQuerySchema,
  ServiceLevelSchema,
  ShippingRateSchema,
  ShippingRatesResponseSchema,
  ShippingRatesErrorSchema,
  ShippingRatesCombinedResponseSchema,
  type ShippingRatesQuery,
  type ServiceLevel,
  type ShippingRate,
  type ShippingRatesResponse,
  type ShippingRatesError,
  type ShippingRatesCombinedResponse,
} from './shipping-rates';

// Seller address
export {
  SellerAddressQuerySchema,
  SellerAddressDetailSchema,
  SellerAddressResponseSchema,
  SellerAddressErrorSchema,
  type SellerAddressQuery,
  type SellerAddressDetail,
  type SellerAddressResponse,
  type SellerAddressError,
} from './seller-address';

// Guest shipping rates
export {
  GuestBuyerAddressSchema,
  GuestShippingRatesRequestSchema,
  ShippingServiceLevelSchema,
  ShippingRateSchema as GuestShippingRateSchema,
  GuestShippingRatesSuccessSchema,
  GuestShippingRatesErrorSchema,
  GuestShippingRatesResponseSchema,
  type GuestBuyerAddress,
  type GuestShippingRatesRequest,
  type ShippingRate as GuestShippingRate,
  type GuestShippingRatesSuccess,
  type GuestShippingRatesError,
  type GuestShippingRatesResponse,
} from './shipping-rates-guest';

// Create payment intent
export {
  PaymentIntentShippingAddressSchema,
  PaymentIntentListingSchema,
  PaymentIntentShippingRateSchema,
  GuestPaymentIntentRequestSchema,
  AuthPaymentIntentRequestSchema,
  CreatePaymentIntentRequestSchema,
  CreatePaymentIntentSuccessSchema,
  CreatePaymentIntentErrorSchema,
  CreatePaymentIntentResponseSchema,
  type PaymentIntentShippingAddress,
  type PaymentIntentListing,
  type PaymentIntentShippingRate,
  type GuestPaymentIntentRequest,
  type AuthPaymentIntentRequest,
  type CreatePaymentIntentRequest,
  type CreatePaymentIntentSuccess,
  type CreatePaymentIntentError,
  type CreatePaymentIntentResponse,
} from './create-payment-intent';
